/* eslint-disable */

/**
 * Dependencies:
 * - Custom select component
 *
 * Required translation strings:
 * - addToCart
 * - noStock
 * - noVariant
 * - onlyXLeft
 */

if (!customElements.get('variant-picker')) {
  class VariantPicker extends HTMLElement {
    constructor() {
      super();
      this.section = this.closest('.js-product');
      this.productForm = this.section.querySelector('.js-product-form');
      this.optionSelectors = this.querySelectorAll('.option-selector');
      this.data = this.getProductData();

      this.updateAvailability();
      this.addEventListener('change', this.handleVariantChange.bind(this));
    }

    /**
     * Handles 'change' events on the variant picker element.
     * @param {object} evt - Event object.
     */
    handleVariantChange(evt) {
      
      const selectedOptions = this.getSelectedOptions();
      this.variant = null;
      // Get selected variant data (if variant exists).
      this.variant = this.data.product.variants.find((v) =>
      v.options.every((val, index) => val === selectedOptions[index])
      );

      if (this.variant) {
        this.updateMedia();
        this.updateUrl(evt);
        this.updateVariantInput();
      }

      this.updateAddToCartButton();
      this.updateAvailability();
      this.updatePrice();
      this.updateBackorderText();
      this.updateBackButtonContent();
      this.updatePickupAvailability();
      this.updateSku();
      VariantPicker.updateLabelText(evt);

      this.dispatchEvent(new CustomEvent('on:variant:change', {
        bubbles: true,
        detail: {
          form: this.productForm,
          variant: this.variant,
          product: this.data.product
        }
      }));
    }

    /**
     * Updates the "Add to Cart" button label and disabled state.
     */
    updateAddToCartButton() {
      this.productForm = this.section.querySelector('.js-product-form');
      if (!this.productForm) return;

      this.addBtn = this.addBtn || this.productForm.querySelector('[name="add"]');
      const variantAvailable = this.variant && this.variant.available;
      const unavailableStr = this.variant ? theme.strings.noStock : theme.strings.noVariant;

      this.addBtn.disabled = !variantAvailable;
      this.addBtn.textContent = variantAvailable
        ? this.addBtn.dataset.addToCartText
        : unavailableStr;
      const addButton = document.querySelector('.product-info__add-to-cart [data-add-to-cart-text="Add to cart"]');
      if (addButton) {
        const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
        svg.setAttribute("width", "10");
        svg.setAttribute("height", "11");
        svg.setAttribute("fill", "none");
        svg.setAttribute("xmlns", "http://www.w3.org/2000/svg");
        svg.setAttribute("viewBox", "0 0 10 11");
        svg.innerHTML = `
          <path d="M3 1.5H9V7.5" stroke="white"></path>
          <path d="M1.25 9.25L8.75 1.75" stroke="white"></path>
        `;
        
        addButton.appendChild(svg);
      }
      
    }

    /**
     * Updates the availability status in option selectors.
     */
    updateAvailability() {
      if (this.dataset.showAvailability === 'false') return;
      let currVariant = this.variant;

      if (!this.variant) {
        currVariant = { options: this.getSelectedOptions() };
      }

      const updateOptionAvailability = (optionEl, available, soldout) => {
        const el = optionEl;
        const text = soldout ? theme.strings.noStock : theme.strings.noVariant;
        el.classList.toggle('is-unavailable', !available);

        if (optionEl.classList.contains('custom-select__option')) {
          const em = el.querySelector('em');

          if (em) {
            em.hidden = available;
          }

          if (!available) {
            if (em) {
              em.textContent = text;
            } else {
              el.innerHTML = `${el.innerHTML} <em class="pointer-events-none">${text}</em>`;
            }
          }
        } else if (!available) {
          el.nextElementSibling.title = text;
        } else {
          el.nextElementSibling.removeAttribute('title');
        }
      };

      // Flag all options as unavailable
      this.querySelectorAll('.js-option').forEach((optionEl) => {
        updateOptionAvailability(optionEl, false, false);
      });

      // Flag selector options as available or sold out, depending on the variant availability
      this.optionSelectors.forEach((selector, selectorIndex) => {
        this.data.product.variants.forEach((variant) => {
          let matchCount = 0;

          variant.options.forEach((option, optionIndex) => {
            if (option === currVariant.options[optionIndex] && optionIndex !== selectorIndex) {
              matchCount += 1;
            }
          });

          if (matchCount === currVariant.options.length - 1) {
            const options = selector.querySelectorAll('.js-option');
            const optionEl = Array.from(options).find((opt) => {
              if (selector.dataset.selectorType === 'dropdown') {
                return opt.firstElementChild.textContent === variant.options[selectorIndex];
              }
              return (
                opt.nextElementSibling.querySelector('.js-value').textContent ===
                variant.options[selectorIndex]
              );
            });

            if (optionEl) {
              updateOptionAvailability(optionEl, variant.available, !variant.available);
            }
          }
        });
      });
    }

    /**
     * Updates the backorder input name for line property item.
     */
  updateBackButtonContent() {
    let productForm = this.productForm;
    let inputVariantBackButtonField = productForm.querySelector('#back-order-metafield');
    if(this.variant.inventory_quantity < 1 && this.variant.inventory_policy === 'continue'){
      if(productForm) {
        let metaVariantButton = variantMetafieldbutton[this.variant.id];
        let metaVariantMessage = variantMetafieldInfo[this.variant.id];
        if(inputVariantBackButtonField && metaVariantMessage && metaVariantButton) {
          inputVariantBackButtonField.value = metaVariantMessage;
          inputVariantBackButtonField.setAttribute("name", `properties[${metaVariantButton}]`);
        } else {
          inputVariantBackButtonField.value = '';
          inputVariantBackButtonField.setAttribute("name", ``);
        }
      }
    } else {
      inputVariantBackButtonField.value = '';
      inputVariantBackButtonField.setAttribute("name", ``);
    }
  }  
  /**
     * Updates the backorder text and visibility.
     */
  updateBackorderText() {
    
    const variantAddInfo = document.getElementById('variantAdditionalInfo');
    const variantAddbutton = document.querySelector('.product-info__add-button');

    const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    svg.setAttribute("width", "10");
    svg.setAttribute("height", "11");
    svg.setAttribute("viewBox", "0 0 10 11");
    svg.setAttribute("fill", "none");

    const path1 = document.createElementNS("http://www.w3.org/2000/svg", "path");
    path1.setAttribute("d", "M3 1.5H9V7.5");
    path1.setAttribute("stroke", "white");

    const path2 = document.createElementNS("http://www.w3.org/2000/svg", "path");
    path2.setAttribute("d", "M1.25 9.25L8.75 1.75");
    path2.setAttribute("stroke", "white");

    svg.appendChild(path1);
    svg.appendChild(path2);

    const appendSVG = () => {
        const svgSpan = document.createElement("span");
        svgSpan.appendChild(svg);
        return svgSpan;
    };

    const showMessage = (message) => {
        variantAddInfo.style.display = "block";
        variantAddInfo.removeAttribute('hidden');
        const getMessage = document.querySelector('.custom_msg');
        const svgMarkup = `
        <svg width="18" height="18" viewBox="0 0 18 18" class="icon" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M9 17C4.5816 17 1 13.4184 1 9C1 4.5816 4.5816 1 9 1C13.4184 1 17 4.5816 17 9C17 13.4184 13.4184 17 9 17ZM9 15.4C10.6974 15.4 12.3253 14.7257 13.5255 13.5255C14.7257 12.3253 15.4 10.6974 15.4 9C15.4 7.30261 14.7257 5.67475 13.5255 4.47452C12.3253 3.27428 10.6974 2.6 9 2.6C7.30261 2.6 5.67475 3.27428 4.47452 4.47452C3.27428 5.67475 2.6 7.30261 2.6 9C2.6 10.6974 3.27428 12.3253 4.47452 13.5255C5.67475 14.7257 7.30261 15.4 9 15.4ZM9.8 9H13V10.6H8.2V5H9.8V9Z" fill="#D80B2A"/>
        </svg>
      `;
        variantAddInfo.textContent = message;
        getMessage.innerHTML = svgMarkup + getMessage.innerHTML;
    };
    const variantId = this.variant.id;
    const varinatsku = this.variant.sku;
    const element = document.querySelector('#variant_box');
    const closestDisclosure = element?.closest('details-disclosure');

    if (variantInTheBox[variantId] !== undefined) {
        closestDisclosure.style.display = "block";
        element.style.display = "block";
        element.innerHTML = variantInTheBox[variantId];
    }
    if (variantInTheBox[variantId] === '') {
        if (element) {
            const hasContent = element.innerHTML.trim() !== '';
            closestDisclosure.style.display = hasContent ? "block" : "none";
        } else {
            console.log("No element with the class 'metafield-rich_text_field' found.");
        }
    }
   
  if (this.variant.inventory_policy === 'continue' && this.variant.inventory_quantity < 1) {
      var bodyElement = document.body;
      let metafieldInfo;
      let metafieldButton;
      if (bodyElement.classList.contains('index-template')) {
          metafieldInfo = document.querySelector('.variant-' + varinatsku).getAttribute('data-info');
          metafieldButton = document.querySelector('.variant-' + varinatsku).getAttribute('value');
      } else {
          metafieldInfo = variantMetafieldInfo[variantId];
          metafieldButton = variantMetafieldbutton[variantId];
      }

      if (metafieldInfo != '' && metafieldButton != '') {
          showMessage(metafieldInfo);
          variantAddbutton.textContent = metafieldButton || "Add to cart";
          variantAddbutton.appendChild(appendSVG());
      }
     else if (variantMetafieldInfo[variantId] === '' && variantMetafieldbutton[variantId] === '') {
        variantAddInfo.style.display = "none";
        variantAddInfo.setAttribute('hidden', 'true');
        variantAddbutton.textContent = this.variant.available ? "Add to cart" : "Sold Out";
        variantAddbutton.appendChild(appendSVG());
      }
      else if (metafieldInfo === '' || metafieldButton === '') {
        if (metafieldButton != '') {
            variantAddbutton.textContent = metafieldButton;
            variantAddbutton.appendChild(appendSVG());
            variantAddInfo.style.display = "none";
            variantAddInfo.setAttribute('hidden', 'true');
        }
        if (metafieldInfo != '') {
            variantAddInfo.style.display = "none";
            variantAddInfo.setAttribute('hidden', 'true');
        }
      }
    } 
     else {
        if (this.variant.available) {
            variantAddbutton.textContent = "Add to cart";
            variantAddbutton.appendChild(appendSVG());
        } else {
            variantAddbutton.textContent = "Sold Out";
            variantAddbutton.appendChild(appendSVG());
        }
        variantAddInfo.style.display = "none";
        variantAddInfo.setAttribute('hidden', 'true');
      }

        
      this.backorder = this.backorder || this.section.querySelector('.backorder');
      if (!this.backorder) return;
     
      let hideBackorder = true;
      
      if (this.variant && this.variant.available) {
    
      const { inventory } = this.data.formatted[this.variant.id];
    
      if (this.variant.inventory_management && inventory === 'none') {
    
        const backorderProdEl = this.backorder.querySelector('.backorder__product');
        const prodTitleEl = this.section.querySelector('.product-title');
        const variantTitle = this.variant.title.includes('Default')
          ? ''
          : ` - ${this.variant.title}`;
      
        backorderProdEl.textContent = `${prodTitleEl.textContent}${variantTitle}`;
        hideBackorder = false;
        variantAddInfo.style.display = "none";
        variantAdditionalInfo.setAttribute('hidden', 'true'); 
        
      }
      }
      
      this.backorder.hidden = hideBackorder;
      }
    /**
     * Updates the color option label text.
     * @param {object} evt - Event object
     */
    static updateLabelText(evt) {
      const selector = evt.target.closest('.option-selector');
      if (selector.dataset.selectorType === 'dropdown') return;

      const colorText = selector.querySelector('.js-color-text');
      if (!colorText) return;

      colorText.textContent = evt.target.nextElementSibling.querySelector('.js-value').textContent;
    }

    /**
     * Updates the product media.
     */
    updateMedia() {
      if (!this.variant.featured_media) return;

      if (this.section.matches('quick-add-drawer')) {
        this.section.updateMedia(this.variant.featured_media.id);
      } else {
        this.mediaGallery = this.mediaGallery || this.section.querySelector('media-gallery');
        if (!this.mediaGallery) return;

        const variantMedia = this.mediaGallery.querySelector(
          `[data-media-id="${this.variant.featured_media.id}"]`
        );
        this.mediaGallery.setActiveMedia(variantMedia, true, true);
      }
    }

    /**
     * Updates the pick up availability.
     */
    updatePickupAvailability() {
      this.pickUpAvailability =
        this.pickUpAvailability || this.section.querySelector('pickup-availability');
      if (!this.pickUpAvailability) return;

      if (this.variant && this.variant.available) {
        this.pickUpAvailability.getAvailability(this.variant.id);
      } else {
        this.pickUpAvailability.removeAttribute('available');
        this.pickUpAvailability.innerHTML = '';
      }
    }

    /**
     * Updates the price.
     */
    updatePrice() {
      this.price = this.price || this.section.querySelector('.product-info__price > .price');
      if (!this.price) return;

      if (this.variant) {
        const priceCurrentEl = this.price.querySelector('.price__current');
        const priceWasEl = this.price.querySelector('.price__was');
        const unitPriceEl = this.price.querySelector('.unit-price');

        // Update current price and original price if on sale.
        priceCurrentEl.textContent = this.data.formatted[this.variant.id].price;
        if (priceWasEl)
          priceWasEl.textContent = this.data.formatted[this.variant.id].compareAtPrice || '';

        // Update unit price, if specified.
        if (this.variant.unit_price_measurement) {
          const valueEl = this.price.querySelector('.unit-price__price');
          const unitEl = this.price.querySelector('.unit-price__unit');
          const value = this.variant.unit_price_measurement.reference_value;
          const unit = this.variant.unit_price_measurement.reference_unit;

          valueEl.textContent = this.data.formatted[this.variant.id].unitPrice;
          unitEl.textContent = value === 1 ? unit : `${value} ${unit}`;
        }

        unitPriceEl.hidden = !this.variant.unit_price_measurement;
        this.price.classList.toggle(
          'price--on-sale',
          this.variant.compare_at_price > this.variant.price
        );
        this.price.classList.toggle('price--sold-out', !this.variant.available);
      }

      this.price.querySelector('.price__default').hidden = !this.variant;
      this.price.querySelector('.price__no-variant').hidden = this.variant;
    }

    /**
     * Updates the SKU.
     */
    updateSku() {
      this.sku = this.sku || this.section.querySelector('.product-sku__value');
      if (!this.sku) return;

      const skuAvailable = this.variant && this.variant.sku;
      this.sku.textContent = skuAvailable ? this.variant.sku : '';
      this.sku.parentNode.hidden = !skuAvailable;
    }

    /**
     * Updates the url with the selected variant id.
     * @param {object} evt - Event object.
     */
    updateUrl(evt) {
      if (!evt || evt.type !== 'change' || this.dataset.updateUrl === 'false') return;
      window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.variant.id}`);
    }

    /**
     * Updates the value of the hidden [name="id"] form inputs.
     */
    updateVariantInput() {
      this.forms =
        this.forms || this.section.querySelectorAll('.js-product-form, .js-instalments-form');

      this.forms.forEach((form) => {
        const input = form.querySelector('input[name="id"]');
        input.value = this.variant.id;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }

    /**
     * Gets the selected option element from each selector.
     * @returns {Array}
     */
    getSelectedOptions() {
      const selectedOptions = [];

      this.optionSelectors.forEach((selector) => {
        if (selector.dataset.selectorType === 'dropdown') {
          selectedOptions.push(selector.querySelector('.custom-select__btn').textContent.trim());
        } else {
          selectedOptions.push(selector.querySelector('input:checked').value);
        }
      });

      return selectedOptions;
    }

    /**
     * Gets the product data.
     * @returns {?object}
     */
    getProductData() {
      const dataEl = this.querySelector('[type="application/json"]');
      return JSON.parse(dataEl.textContent);
    }
  }

  customElements.define('variant-picker', VariantPicker);
}
